import React from "react"
import Layout from "../components/layout"
import SiteCategories from "../components/SiteCategories/SiteCategories"
import SEO from "../components/seo"

const AllCategories = () => {
  return (
    <Layout>
      <SEO title="Categories"/>
      <SiteCategories/>
    </Layout>
  )
}

export default AllCategories
